
<template>
    <div class="team-area pt-100 pb-75" v-if="data?.length">
      <div class="section-title">
        <span class="sub-title text-uppercase  ">Technologies We are Expert in</span>
      </div>
      <div class="container">
        <div class="row justify-content-center">
          <div
            class="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-4"
            v-for="technlology in data"
            :key="technlology?.name"
          >
            <div class="single-team-box">
              <!-- <div class="image"> -->
              <div>
                <img
                  :src="
                    baseUrl + technlology?.logo?.url
                  "
                />
              </div>
              <!-- </div> -->
              <div class="content">
                <!-- <h3>{{ technlology?.attributes?.name }}</h3> -->
                <!-- <span>Client since 2018</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ServiceTeam",
    props:{
       data:[],
      },
    data() {
      return {
        baseUrl: "https://backend.meander.software/",
      };
    },
  };
  </script>
  